var path = '/Users/bc/Code/open-source/angular-keypad/src/templates/backspace-left.html';
var html = "<button class=\"bc-keypad__key-button bc-keypad__key-button--backspace\" data-ng-click=\"vm.leftButtonTrigger($event, vm.bcLeftButton)\" angular-ripple aria-role=Backspace> <ng-include src=\" vm.bcKeypadConfig.backspaceTemplate \"></ng-include> </button> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/backspace-left.html
 ** module id = 6
 ** module chunks = 0 1
 **/